import { STheme } from 'src/rest/types/api/Theme'

type ColorVariant = 'Primary' | 'Secondary'

export const getThemeColor = (
  theme?: STheme | any,
  type: ColorVariant = 'Primary'
) => {
  // Strapi v4 wraps relations as `{ data: { attributes: {...} } }`; v5 returns
  // them flat. Accept any of: flat, single-attributes wrapper, or data+attributes.
  const t: any = theme
  const attrs: any = t?.data?.attributes ?? t?.attributes ?? t
  return (
    attrs?.[type === 'Primary' ? 'tertiaryOne' : 'tertiaryTwo'] || undefined
  )
}
